import { loadComponent } from "./load-component";
import { loadScript } from "./load-script";

export async function importRemote(src: string, scope: string, module: string) {
  await loadScript(src);

  return loadComponent(scope, module);
}
